export default class Locale_PluginInvoker {
	AuthenticationExpired: string = "Authentication expired";
	AuthenticationExpiredDescription: string = "Your authentication with Team Planner has expired and you need to refresh the page";
}